<template>
  <div class="trading-section">
    <div id="accountPicker" style="margin-bottom: 20px">
      <el-select v-model="operateData" :placeholder="$t('stock.pleaseSelectAccount')" style="width: 100%"
        @change="refreshData">
        <el-option v-for="item in operateOptions" :key="item.cid" id="accountSelector"
          :label="item.name + '(' + item.order + ')' + $t('stock.balance') + item.use" :value="item.cid">
        </el-option>
      </el-select>
    </div>
    <el-tabs id="tabs" stretch style="background-color: rgb(4, 15, 27)" v-model="tabsName" @tab-click="handleClick">
      <el-tab-pane :label="$t('stockTrading.openPosition')" name="buyStock" id="buystock">
        <el-row :gutter="10">
          <el-col :span="14">
            <el-form label-width="0" :model="stockBuy" size="medium">
              <el-form-item>
                <el-select v-model="stockBuy.info" filterable remote :remote-method="remoteMethod" :loading="loading"
                  :placeholder="$t('stock.codeNameShort')" @change="changeRouteInfo('buy', true)" size="small"
                  class="full_width">
                  <el-option v-for="item in options" :key="item.short" :label="item.name + ' ' + item.short"
                    :value="item.short">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-row>
                  <el-col :span="8">
                    <el-button
                      type="primary"
                      @click="changePrice('buy')"
                      v-if="changeBuyType"
                      size="small"
                      class="full_width"
                      style="background-color: var(--baseColor);border-color:var(--baseColor)"
                      >{{$t('stock.marketPrice')}}</el-button
                    >
                    <el-button
                      type="primary"
                      @click="changePrice('buy')"
                      v-else
                      size="small"
                      class="full_width"
                      style="background-color: var(--baseColor);border-color:var(--baseColor)"
                      >{{$t('stock.priceLimit')}}</el-button
                    >
                  </el-col>
                  <el-col :span="16">
                    <el-input :disabled="true" v-if="changeBuyType" size="small" class="full_width"
                      :placeholder="$t('stock.marketBuy')"></el-input>
                    <el-input v-model="stockBuy.limitPrice" v-else size="small" class="full_width"
                      :placeholder="$t('stock.buyingPrice')" type="number"></el-input>
                  </el-col>
                </el-row>
                <p style="color: #fff">
                  {{ $t('stock.highPrice') }}:<span style="padding-right: 50px">{{
                    stockBuy.hardenPrice
                  }}</span>{{ $t('stock.limitPrice') }}:<span>{{ stockBuy.dropPrice }}</span>
                </p>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-input v-model="stockBuy.number" size="small" type="number"
                  :placeholder="$t('stock.buyingVolume')"></el-input>
                <p v-if="changeBuyType" style="color: #ffffff">
                  {{ $t('stockTrading.availableShares') }}：<span>{{ buyMarketPrice }}</span>
                </p>
                <p v-else style="color: #ffffff">
                  {{ $t('stockTrading.availableShares') }}：<span>{{ buyLimitPrice }}</span>
                </p>
              </el-form-item>
              <el-form-item style="margin-bottom: 10px">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-button class="full_width option-btn" size="small" @click="position('buyFull')">{{
                      $t('stock.fullPosition') }}</el-button>
                  </el-col>
                  <el-col :span="6">
                    <el-button class="full_width option-btn" size="small"
                      @click="position('buyThreeFourths')">3/4</el-button>
                  </el-col>
                  <el-col :span="6">
                    <el-button class="full_width option-btn" size="small"
                      @click="position('buyTwoFourths')">1/2</el-button>
                  </el-col>
                  <el-col :span="6">
                    <el-button class="full_width option-btn" size="small"
                      @click="position('buyOneFourths')">1/4</el-button>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label-width="0">
                <el-button
                  type="primary submit"
                  size="small"
                  @click="buyStock"
                  style="padding: 15px 0px;background-color: var(--baseColor);border-color:var(--baseColor)"
                  :style="{ opacity: isCapitalNotSelected ? 0.5 : 1 }"                      
                  >{{$t('stockTrading.longOpen')}}</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="10">
            <el-card class="box-card" shadow="never">
              <el-row>
                <div class="center box-market" v-for="(item, index) in stockBuy.sellArr" :key="index">
                  <el-col :span="8">{{ item.id }}</el-col>
                  <el-col :span="8" class="red">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </div>
              </el-row>
            </el-card>
            <el-card class="box-card" shadow="never" style="margin-top: 10px">
              <el-row>
                <p class="center box-market" v-for="(item, index) in stockBuy.buyArr" :key="index">
                  <el-col :span="8">{{ item.id }}</el-col>
                  <el-col :span="8" class="green">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </p>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="24" id="buystockTableBottom">
            <el-table :data="holdData" height="255px" @row-click="buyHanddle" size="small"
              style="width: 100%; background-color: #040f1b" id="buystockTable" :header-cell-style="{
                background: '#040F1B',
                color: '#FFFFFF',
                border: 'none',
              }" :cell-style="{ background: '#040f1b' }">
              <el-table-column :label="$t('stock.nameMarketCap')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.name }}</p>
                    <p class="green">{{ scope.row.market }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.name }}</p>
                    <p class="red">{{ scope.row.market }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.openAvail')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.number }}</p>
                    <p class="green">{{ scope.row.sellable }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.number }}</p>
                    <p class="red">{{ scope.row.sellable }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.currentPriceAvgPrice')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.newPrice }}</p>
                    <p class="green">{{ scope.row.price }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.newPrice }}</p>
                    <p class="red">{{ scope.row.price }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.totProfitLoss')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.profitMarket }}</p>
                    <p class="green">{{ scope.row.priceRatio }}%</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.profitMarket }}</p>
                    <p class="red">{{ scope.row.priceRatio }}%</p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane :label="$t('stockTrading.closePosition')" name="sellStock" id="buystock">
        <el-row :gutter="10">
          <el-col :span="14">
            <el-form :model="stockSell" size="medium">
              <el-form-item>
                <el-select v-model="stockSell.info" filterable remote :remote-method="remoteMethod" :loading="loading"
                  :placeholder="$t('stock.codeNameShort')" @change="changeRouteInfo('sell', true)" size="small"
                  class="full_width">
                  <el-option v-for="item in options" :key="item.short" :label="item.name + ' ' + item.short"
                    :value="item.short">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-row>
                  <el-col :span="8">
                    <el-button
                      type="primary"
                      @click="changePrice('sell')"
                      v-if="changeSellType"
                      size="small"
                      class="full_width"
                      style="background-color: var(--baseColor);border-color:var(--baseColor)"
                      >{{$t('stock.marketPrice')}}</el-button
                    >
                    <el-button
                      type="primary"
                      @click="changePrice('sell')"
                      v-else
                      size="small"
                      class="full_width"
                      style="background-color: var(--baseColor);border-color:var(--baseColor)"
                      >{{$t('stock.priceLimit')}}</el-button
                    >
                  </el-col>
                  <el-col :span="16">
                    <el-input v-if="changeSellType" :disabled="true" size="small" class="full_width"
                      :placeholder="$t('stock.sellAtMarketPrice')"></el-input>
                    <el-input v-model="stockSell.limitPrice" v-else size="small" class="full_width"
                      :placeholder="$t('stock.sellingPrice')" type="number"></el-input>
                  </el-col>
                </el-row>
                <p style="color: #fff">
                  {{ $t('stock.limitPriceNew') }}:<span style="padding-right: 50px">{{
                    stockSell.hardenPrice
                  }}</span>{{ $t('stockTrading.limitPrice') }}:<span>{{ stockSell.dropPrice }}</span>
                </p>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-input v-model="stockSell.number" size="small" :placeholder="$t('stock.salesVolume')"></el-input>
                <p style="color: #ffffff">
                  {{ $t('stockTrading.availableSharesForSale') }}: <span>{{ parseInt(stockSell.validNumber) }}</span>
                </p>
              </el-form-item>
              <el-form-item style="margin-bottom: 10px">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-button class="full_width option-btn" size="small" @click="position('sellFull')">{{
                      $t('stock.fullPosition') }}</el-button>
                  </el-col>
                  <el-col :span="6">
                    <el-button class="full_width option-btn" size="small"
                      @click="position('sellThreeFourths')">3/4</el-button>
                  </el-col>
                  <el-col :span="6">
                    <el-button class="full_width option-btn" size="small"
                      @click="position('sellTwoFourths')">1/2</el-button>
                  </el-col>
                  <el-col :span="6">
                    <el-button class="full_width option-btn" size="small"
                      @click="position('sellOneFourths')">1/4</el-button>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label-width="0">
                <el-button
                  type="primary submit"
                  size="small"
                  @click="sellStock"
                  style="padding: 15px 0px;background-color: var(--baseColor);border-color:var(--baseColor)"
                  :style="{ opacity: isCapitalNotSelected ? 0.5 : 1 }"                      
                  >{{$t('stockTrading.longClose')}}</el-button
                >
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="10">
            <el-card class="box-card" shadow="never">
              <el-row>
                <div class="center box-market" v-for="(item, index) in stockSell.sellArr" :key="index">
                  <el-col :span="8">{{ item.id }}</el-col>
                  <el-col :span="8" class="red">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </div>
              </el-row>
            </el-card>
            <el-card class="box-card" shadow="never" style="margin-top: 10px">
              <el-row>
                <p class="center box-market" v-for="(item, index) in stockSell.buyArr" :key="index">
                  <el-col :span="8">{{ item.id }}</el-col>
                  <el-col :span="8" class="green">{{ item.price }}</el-col>
                  <el-col :span="8">{{ item.number }}</el-col>
                </p>
              </el-row>
            </el-card>
          </el-col>
          <el-col :span="24" id="buystockTableBottom">
            <el-table :data="holdData" height="255px" @row-click="sellHanddle" size="small" id="buystockTable"
              style="width: 100%; background-color: #040f1b" :header-cell-style="{
                background: '#040F1B',
                color: '#FFFFFF',
                border: 'none',
              }" :cell-style="{ background: '#040f1b' }">
              <el-table-column :label="$t('stock.nameMarketCap')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.name }}</p>
                    <p class="green">{{ scope.row.market }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.name }}</p>
                    <p class="red">{{ scope.row.market }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.openAvail')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.number }}</p>
                    <p class="green">{{ scope.row.sellable }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.number }}</p>
                    <p class="red">{{ scope.row.sellable }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.currentPriceAvgPrice')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.priceRatio.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.newPrice }}</p>
                    <p class="green">{{ scope.row.price }}</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.newPrice }}</p>
                    <p class="red">{{ scope.row.price }}</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.totProfitLoss')" align="center">
                <template slot-scope="scope">
                  <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                    <p class="green">{{ scope.row.profitMarket }}</p>
                    <p class="green">{{ scope.row.priceRatio }}%</p>
                  </div>
                  <div v-else>
                    <p class="red">{{ scope.row.profitMarket }}</p>
                    <p class="red">{{ scope.row.priceRatio }}%</p>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane :label="$t('stock.cancelation')" name="canceStock" id="buystockTableBottom">
        <el-table :data="cancelData" height="588px" size="small" style="width: 100%; background-color: #040f1b"
          id="buystockTable" :header-cell-style="{
            background: '#040F1B',
            color: '#FFFFFF',
            border: 'none',
          }" :cell-style="{ background: '#040f1b' }">
          <el-table-column :label="$t('stock.stockTime')" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.name }}</p>
              <p>{{ scope.row.accurate }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('stock.commisionPrice')" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.deal }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('stock.entrustClose')" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.number }}</p>
              <p>{{ scope.row.finish }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('stock.businessStatus')" align="center">
            <template slot-scope="scope">
              <p>{{ scope.row.type }}</p>
              <p>{{ scope.row.status }}</p>
            </template>
          </el-table-column>
          <el-table-column :label="$t('stock.operate')" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="handleCance(scope.row)">{{ $t('stock.cancelation')
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('stockTrading.position')" name="holdStock" id="buystockTableBottom">
        <el-table height="588px" size="small" :data="holdData" style="width: 100%; background-color: #040f1b"
          id="buystockTable" :header-cell-style="{
            background: '#040F1B',
            color: '#FFFFFF',
            border: 'none',
          }" :cell-style="{ background: '#040f1b' }">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-form label-position="left" inline class="demo-table-expand">
                <el-row>
                  <el-col :span="8" class="center">
                    <el-button
                      type="primary"
                      style="background-color: var(--baseColor);border-color:var(--baseColor)"
                      size="small"
                      @click="holdBuy(props.row.short)"
                      >{{$t('stock.buy')}}</el-button
                    >
                  </el-col>
                  <el-col :span="8" class="center">
                    <el-button
                      type="primary"
                      style="background-color: var(--baseColor);border-color:var(--baseColor)"
                      size="small"
                      @click="holdSell(props.row.short)"
                      >{{$t('stock.sell')}}</el-button
                    >
                  </el-col>
                  <el-col :span="8" class="center">
                    <el-button
                      type="primary"
                      style="background-color: var(--baseColor);border-color:var(--baseColor)"
                      size="small"
                      @click="marketGo(props.row.short)"
                      >{{$t('stock.quotes')}}</el-button
                    >
                  </el-col>
                </el-row>
              </el-form>
            </template>
          </el-table-column>
          <el-table-column :label="$t('stock.nameMarketCap')">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.name }}</p>
                <p class="green">{{ scope.row.market }}</p>
              </div>
              <div v-else>
                <p class="red">{{ scope.row.name }}</p>
                <p class="red">{{ scope.row.market }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('stock.openAvail')">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.number }}</p>
                <p class="green">{{ scope.row.sellable }}</p>
              </div>
              <div v-else>
                <p class="red">{{ scope.row.number }}</p>
                <p class="red">{{ scope.row.sellable }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('stock.currentPriceAvgPrice')">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.newPrice }}</p>
                <p class="green">{{ scope.row.price }}</p>
              </div>
              <div v-else>
                <p class="red">{{ scope.row.newPrice }}</p>
                <p class="red">{{ scope.row.price }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('stock.totProfitLoss')">
            <template slot-scope="scope">
              <div v-if="scope.row.profitMarket.substr(0, 1) === '-'">
                <p class="green">{{ scope.row.profitMarket }}</p>
                <p class="green">{{ scope.row.priceRatio }}%</p>
              </div>
              <div v-else>
                <p class="red">{{ scope.row.profitMarket }}</p>
                <p class="red">{{ scope.row.priceRatio }}%</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane :label="$t('stock.inquire')">
        <el-tabs stretch>
          <el-tab-pane :label="$t('stock.commisionedQuery')" id="buystockTableBottom">
            <el-table size="small" height="534px" :data="entrustData" style="width: 100%; background-color: #040f1b"
              id="buystockTable" :header-cell-style="{
                background: '#040F1B',
                color: '#FFFFFF',
                border: 'none',
              }" :cell-style="{ background: '#040f1b', color: '#FFFFFF' }">
              <el-table-column :label="$t('stock.dateTime')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.time }}</p>
                  <p>{{ scope.row.accurate }}&nbsp;</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.nameCode')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.code }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.buyStatus')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.type }}</p>
                  <p>{{ scope.row.status }}&nbsp;</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.entrustTransactionPrice')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.deal }}&nbsp;</p>
                  <p>{{ scope.row.price }}&nbsp;</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.orderTradeVol')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.number }}&nbsp;</p>
                  <p>{{ scope.row.finish }}&nbsp;</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane :label="$t('stock.transactionRecord')" id="buystockTableBottom">
            <el-table size="small" height="534px" :data="dealData" style="width: 100%; background-color: #040f1b"
              id="buystockTable" :header-cell-style="{
                background: '#040F1B',
                color: '#FFFFFF',
                border: 'none',
              }" :cell-style="{ background: '#040f1b', color: '#FFFFFF' }">
              <el-table-column type="expand">
                <template slot-scope="props" style="background-color: #040F1B;">
                  <el-form label-position="right" size="mini">
                    <el-form-item :label="$t('stock.timeDate')">
                      <p class="right">
                        {{ props.row.time }} {{ props.row.accurate }}
                      </p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.businessName')">
                      <p class="right">{{ props.row.type }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.stockCode')">
                      <p class="right">
                        {{ props.row.name }} {{ props.row.code }}
                      </p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.numOfTrans')">
                      <p class="right">{{ props.row.number }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.dealPrice')">
                      <p class="right">{{ props.row.price }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.turnoverNew')">
                      <p class="right">{{ props.row.total }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.brokeCom')">
                      <p class="right">{{ props.row.commission }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.transferFee')" v-if="props.row.short && props.row.short.startsWith('sh')">
                      <p class="right">{{ props.row.change }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.handleFee')" v-if="props.row.short && props.row.short.startsWith('sh')">
                      <p class="right">{{ props.row.handle }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.regularFee')" v-if="props.row.short && props.row.short.startsWith('sz')">
                      <p class="right">{{ props.row.regular }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.stampDuty')">
                      <p class="right">{{ props.row.stamp }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.productHandlingFee')">
                      <p class="right">{{ props.row.extra_fee1 }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.setllementFee')">
                      <p class="right">{{ props.row.extra_fee2 }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.platformFee')">
                      <p class="right">{{ props.row.extra_fee3 }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.lumpSee')">
                      <p class="right">{{ props.row.totalplus }}</p>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.dateTime')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.time }}</p>
                  <p>{{ scope.row.accurate }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.nameCode')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.code }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.buyQuantity')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.type }}</p>
                  <p>{{ scope.row.number }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.unitPriceTotPrice')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.price }}</p>
                  <p>{{ scope.row.total }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane :label="$t('stock.sysClose')" id="buystockTableBottom">
            <el-table size="small" height="534px" :data="unwindData" style="width: 100%; background-color: #040f1b"
              id="buystockTable" :header-cell-style="{
                background: '#040F1B',
                color: '#FFFFFF',
                border: 'none',
              }" :cell-style="{ background: '#040f1b' }">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-form label-position="right" size="mini">
                    <el-form-item :label="$t('stock.timeDate')">
                      <p class="right">
                        {{ props.row.time }} {{ props.row.accurate }}
                      </p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.businessName')">
                      <p class="right">{{ props.row.type }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.stockCode')">
                      <p class="right">
                        {{ props.row.name }} {{ props.row.code }}
                      </p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.numOfTrans')">
                      <p class="right">{{ props.row.number }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.dealPrice')">
                      <p class="right">{{ props.row.price }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.brokeCom')">
                      <p class="right">{{ props.row.commission }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.transferFee')">
                      <p class="right">{{ props.row.change }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.stampDuty')">
                      <p class="right">{{ props.row.stamp }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('stock.lumpSee')">
                      <p class="right">{{ props.row.total }}</p>
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.dateTime')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.time }}</p>
                  <p>{{ scope.row.accurate }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.nameCode')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.code }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.buyQuantity')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.type }}</p>
                  <p>{{ scope.row.number }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.unitPriceTotPrice')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.price }}</p>
                  <p>{{ scope.row.total }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane :label="$t('stock.statement')" id="buystockTableBottom">
            <el-table height="534px" size="small" :data="capitalData" style="width: 100%; background-color: #040f1b"
              id="buystockTable" :header-cell-style="{
                background: '#040F1B',
                color: '#FFFFFF',
                border: 'none',
              }" :cell-style="{ background: '#040f1b', color: '#FFFFFF' }">
              <el-table-column :label="$t('stock.date')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.create_time.toString().split(' ')[0] }}</p>
                  <p>{{ scope.row.create_time.toString().split(' ')[1] }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.nameType')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.name }}</p>
                  <p>{{ scope.row.type }}</p>
                </template>
              </el-table-column>
              <el-table-column :label="$t('stock.amountBal')" align="center">
                <template slot-scope="scope">
                  <p>{{ scope.row.number }}</p>
                  <p>{{ scope.row.balance }}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
    </el-tabs>
    <!-- ============================== Start change channel popup ========================== -->
    <el-dialog :visible.sync="showTradeChannelPopup" width="40%" center custom-class="tradingChannelPop">
      <div v-html="trade_rules_content_top"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agreeTradeRules()"
          style="background: #ff0000; border-color: #ff0000; width: 200px">{{ $t('stock.iUnderstand') }}
        </el-button>
        <div v-html="trade_rules_content_bottom" style="padding-top: 10px"></div>
      </span>
    </el-dialog>
    <!-- ============================== end change channel popup ========================== -->

     <!-- ============================== return to capital page popup ========================== -->
     <el-dialog :visible.sync="isCapitalEmpty"  center custom-class="returntoCapital" :show-close="false"   :close-on-click-modal="false"
     >
      <el-row>
  <el-col :span="1">
    <span class="el-icon-error" style="color: #f56c6c;"></span>
  </el-col>

  <el-col :span="23">
    <p style="text-align: center; font-size: 17px; color:#C00000;margin-top: -5px;">
      {{ $t('trading.returnToCapital') }}
    </p>
  </el-col>
</el-row>

            <span slot="footer" class="dialog-footer">
              <router-link  :to="{ path: '/operate/operateday'}" >
        <el-button type="primary"   
          style="background: #CE4D32; border-color: #CE4D32;color:white; width: 150px">{{ $t('trading.applyCapital') }}
        </el-button>
      </router-link>
      </span>
    </el-dialog>
    <!-- ============================== end  popup ========================== -->
  </div>
</template>

<script>
import $ from "jquery";
import eventBus from "../assets/js/eventBus";

export default {
  name: "stocktrading",
  data() {
    return {
      tradeDirection: this.$route.query.direction || 0,
      tabsName: "buyStock",
      //股票买入
      stockBuy: {
        info: "",
        marketPrice: "", //市价
        limitPrice: "", //现价
        hardenPrice: 0, //涨停
        dropPrice: 0, //跌停
        number: "",
        buyArr: [
          {
            id: "买1",
            price: "- -",
            number: "- -",
          },
          {
            id: "买2",
            price: "- -",
            number: "- -",
          },
          {
            id: "买3",
            price: "- -",
            number: "- -",
          },
          {
            id: "买4",
            price: "- -",
            number: "- -",
          },
          {
            id: "买5",
            price: "- -",
            number: "- -",
          },
        ], //五档行情
        sellArr: [
          {
            id: "卖5",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖4",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖3",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖2",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖1",
            price: "- -",
            number: "- -",
          },
        ],
      },
      //股票卖出
      stockSell: {
        info: "",
        marketPrice: "", //市价
        limitPrice: "", //现价
        hardenPrice: 0, //涨停
        dropPrice: 0, //跌停
        number: "",
        buyArr: [
          {
            id: "买1",
            price: "- -",
            number: "- -",
          },
          {
            id: "买2",
            price: "- -",
            number: "- -",
          },
          {
            id: "买3",
            price: "- -",
            number: "- -",
          },
          {
            id: "买4",
            price: "- -",
            number: "- -",
          },
          {
            id: "买5",
            price: "- -",
            number: "- -",
          },
        ], //五档行情
        sellArr: [
          {
            id: "卖5",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖4",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖3",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖2",
            price: "- -",
            number: "- -",
          },
          {
            id: "卖1",
            price: "- -",
            number: "- -",
          },
        ],
        validNumber: 0,
      },
      //撤单
      cancelData: [],
      //持仓
      holdData: [],
      //委托
      entrustData: [],
      //成交
      dealData: [],
      //账户信息
      operateOptions: [],
      //选中账户
      operateData: "",
      //流水资金
      capitalData: [],
      //修改市价限价
      changeBuyType: true,
      changeSellType: true,
      //用户可用余额
      UserAvailable: 0,
      //远程搜索
      loading: false,
      options: [],
      transmitCid: 0,
      unwindData: [],
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      fullscreenLoading: false,
      newPriceTimer: null,
      depotContentLength: 0,
      stockFee:"",
      totalFee:0,
      isCapitalNotSelected:false,
      isCapitalEmpty:false,

    };
  },
  computed: {
    //下拉框数据
    restaurants: function () {
      return this.$store.state.restaurants;
    },
    //买入市价计算
    buyMarketPrice: function () {
      let that = this;

      this.totalFee = 0;
      let change = 0;
      let money = that.UserAvailable;
      let commission = that.stockFee.buy * money;
      let stockCode = that.stockBuy.info.slice(0,2);
      if(stockCode.toString().toLowerCase() == 'sh'){
        change = that.stockFee.change * money;
      } else {
        commission = commission < that.stockFee.plus_fee ? that.stockFee.plus_fee : commission;
      }
      this.totalFee = Number(that.stockFee.stamp) + Number(change) + Number(commission) + Number(that.stockFee.extra_fee1) 
      + Number(that.stockFee.extra_fee2) + Number(that.stockFee.extra_fee3);

      let marketPrice = parseInt((
        Number(that.UserAvailable) - Number(this.totalFee)) / Number(that.stockBuy.marketPrice)
      );
      if (isNaN(marketPrice) || marketPrice < 0) {
        return 0;
      } else {
        return marketPrice;
      }
    },
    //买入限价计算
    buyLimitPrice: function () {
      let that = this;

      this.totalFee = 0;
      let change = 0;
      let money = that.UserAvailable;
      let commission = that.stockFee.buy * money;
      let stockCode = that.stockBuy.info.slice(0,2);
      if(stockCode.toString().toLowerCase() == 'sh'){
        change = that.stockFee.change * money;
      } else {
        commission = commission < that.stockFee.plus_fee ? that.stockFee.plus_fee : commission;
      }
      this.totalFee = Number(that.stockFee.stamp) + Number(change) + Number(commission) + Number(that.stockFee.extra_fee1) 
      + Number(that.stockFee.extra_fee2) + Number(that.stockFee.extra_fee3);
      
      let limitPrice = parseInt((
        Number(that.UserAvailable) - Number(this.totalFee)) / Number(that.stockBuy.limitPrice)
      );
      if (isNaN(limitPrice) || limitPrice < 0) {
        return 0;
      } else {
        return limitPrice;
      }
    },
  },
  methods: {
    getStockFee() {
      let that = this;
      that
        .$http({
          url: "/app/Stock/stockFee",
          method: "post",
          data: {},
        })
        .then((res) => {
          if (res.data.status == 200) {
            that.stockFee = res.data.data;
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    refreshData() {
      this.fullscreenLoading = true;
      clearInterval(this.newPriceTimer);
      setTimeout(() => {
        if (this.$store.state.loginType) {
          this.changeOperate();
        }
        this.fullscreenLoading = false;
      }, 0);
    },
    //获取持仓信息
    getHoldData() {
      // token need to check setInterval calling time
      const token = sessionStorage.getItem("token");
      if(token){
        let that = this;

        // clearInterval(that.newPriceTimer);
        // console.log("Interval cleared...");
        that
          .$http({
            url: "/app/Depot/depot_stock",
            method: "post",
            data: {
              cid: that.operateData,
              direction: 0,
            },
          })
          .then((res) => {
            if(that.operateData==""|| that.operateData==null){
              that.holdData = [];
            }
            else if (res.data.status == 200) {

              that.depotContentLength = res.data.data.length;

              var dataArr = res.data.data;
              var shortArr = [];
              if (dataArr.length > 0) {
                $.each(dataArr, function (index, item) {
                  shortArr.push(item.short);
                });
                that.getNewPrice(shortArr, dataArr);

                // if (that.newPriceTimer) {
                //   clearInterval(that.newPriceTimer);
                // }

                // that.newPriceTimer = setInterval(function () {
                //   that.getNewPrice(shortArr, dataArr);
                // }, 1000);
              } else {
                // clearInterval(that.newPriceTimer);
                that.holdData = [];
              }
            } else {
              that.$message.error(that.$t(res.data.msgId));
            }
          });
      }
    },
    //请求当前价 计算 盈亏  盈亏比例
    getNewPrice(shortArr, dataArr) {
      let that = this;
      $.ajax({
        url: "https://qt.gtimg.cn/q=" + shortArr.toString(),
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          var i, elements;
          for (i = 0; i < shortArr.length; i++) {
            var elements = eval("v_" + shortArr[i]).split("~");
            dataArr[i]["newPrice"] = elements[3]; //当前价
            var newPrice = parseFloat(elements[3]); //当前价
            // dataArr[i]["newPrice"] = elements[9]; //当前价
            // var newPrice = parseFloat(elements[9]); //当前价
            var number = parseFloat(dataArr[i].number); //持有股数
            var costPrice = parseFloat(dataArr[i].price); //成本价
            var profitPrice = Number((newPrice - costPrice).toFixed(2)); //盈亏金额
            var priceRatio = ((newPrice - costPrice) / costPrice) * 100; //盈亏比例
            var market = (newPrice * number).toFixed(2); //当前市值
            let profitMarket = (
              newPrice * number -
              dataArr[i].costtotal
            ).toFixed(2); //浮动亏损
            priceRatio = priceRatio.toFixed(2);
            dataArr[i]["profitPrice"] = profitPrice;
            dataArr[i]["priceRatio"] = priceRatio;
            dataArr[i]["market"] = market;
            dataArr[i]["profitMarket"] = profitMarket;
          }
          
          if (that.depotContentLength != 0) {
            that.holdData = dataArr;
          }
        },
      });
    },
    //获取全部委托信息
    getEntrustData() {
      let that = this;
      that
        .$http({
          url: "/app/Capital/entrust_log",
          method: "post",
          data: {
            cid: that.operateData,
            direction: 0,
          },
        })
        .then((res) => {
          if(that.operateData==""|| that.operateData==null){
            that.entrustData = [];
          }
          else if (res.data.status == 200) {
            let entrustData = res.data.data;
            if (entrustData.length > 0) {
              for (let i = 0, len = entrustData.length; i < len; i++) {
                if (Number(entrustData[i].deal) === 0) {
                  entrustData[i].deal = "--";
                }
                if (Number(entrustData[i].price) === 0) {
                  entrustData[i].price = "--";
                }
              }
              that.entrustData = entrustData;
            } else {
              that.entrustData = [];
            }

          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //获取全部成交订单
    getDealData() {
      let that = this;
      that
        .$http({
          url: "/app/Capital/deal_log",
          method: "post",
          data: {
            cid: that.operateData,
            direction: 0,
          },
        })
        .then((res) => {
          if(that.operateData==""|| that.operateData==null){
            that.dealData = [];
            that.unwindData = [];
          }
          else if (res.data.status == 200) {
            let dealData = res.data.data;
            if (dealData.length > 0) {
              let unwindData = [];
              for (let i = 0, len = dealData.length; i < len; i++) {
                if (dealData[i].depot_mold === 1) {
                  unwindData.push(dealData[i]);
                }
              }
              that.unwindData = unwindData;
              that.dealData = dealData;
            } else {
              that.dealData = [];
              that.unwindData = [];
            }

          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //获取全部撤单
    getCancelData() {
      let that = this;
      that
        .$http({
          url: "/app/Capital/cancel_order",
          method: "post",
          data: {
            cid: that.operateData,
            direction: 0,
          },
        })
        .then((res) => {
          if(that.operateData==""|| that.operateData==null){
            that.cancelData=[];
          }
        else if (res.data.status == 200) {
            if (res.data.data.length > 0) {
              that.cancelData = res.data.data;

            } else {
              that.cancelData = [];
            }
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //获取账户号
    getOperate() {
  let that = this;
  that
    .$http({
      url: "/app/Capital/current_operate",
      method: "post",
      data: {
        direction: 0,
      },
    })
    .then((res) => {
      if (res.data.status == 200) {
        that.operateOptions = res.data.data.filter(item => item.direction_capital != 1);

        if (res.data.data.length == 0) {
           return that.isCapitalEmpty = true;
        }

        if (that.$route.query.cid) {
          that.operateData = parseInt(that.$route.query.cid);
        } else {
          if (that.operateData === "") {
            that.operateData = that.operateOptions[0].cid;
          }
        }

        that.changeOperate();
      } else {
        that.$message.error(that.$t(res.data.msgId));
      }
    })
    .catch((error) => {
        that.isCapitalNotSelected = true;
        that.$message.error(that.$t('trading.retrun_to_previous_page'));      
    });

    },
    //获取用户子账户可用余额
    getUserAvailable() {
      let that = this;
      that
        .$http({
          url: "/app/Capital/current_detailed",
          method: "post",
          data: {
            cid: that.operateData,
            direction: 0,
          },
        })
        .then((res) => {
          if(that.operateData==""|| that.operateData==null){
            that.UserAvailable=0;
          }
          else if (res.data.status == 200) {
            that.UserAvailable = res.data.data.available;
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //更改账户
    changeOperate(cid) {
      let that = this;
      that.$route.query.cid = that.operateData;
      that.depotContentLength = 0;
      setTimeout(() => {
        that.newPriceTimer = setInterval(function () {
          that.getHoldData();
        }, 3000);
        that.getEntrustData();
        that.getDealData();
        that.getCancelData();
        that.getCapitalData();
        that.getUserAvailable();
      }, 500);
    },
    //获取资金流水
    getCapitalData() {
      let that = this;
      that
        .$http({
          url: "/app/CapitalLog/capital_log",
          method: "post",
          data: {
            'capital': that.operateData,
          },
        })
        .then((res) => {
          if(that.operateData==""|| that.operateData==null){
            that.capitalData = [];
          }
          else if (res.data.status == 200) {
            let capitalData = res.data.data;
            if (capitalData.length > 0) {
              // for (let i = 0, len = capitalData.length; i < len; i++) {
              //   capitalData[i].accurate = that
              //     .$moment(capitalData[i].time)
              //     .format("HH:mm:ss");
              //   capitalData[i].time = that
              //     .$moment(capitalData[i].time)
              //     .format("YYYY.MM.DD");
              // }
              that.capitalData = capitalData;
            } else {
              that.capitalData = [];
            }

          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //修改市价限价
    changePrice(deal) {
      let that = this;
      if (deal === "buy") {
        that.changeBuyType
          ? (that.changeBuyType = false)
          : (that.changeBuyType = true);
        that.changeBuyType
          ? ""
          : (that.stockBuy.limitPrice = that.stockBuy.marketPrice);
      } else if (deal === "sell") {
        that.changeSellType
          ? (that.changeSellType = false)
          : (that.changeSellType = true);
        that.changeSellType
          ? ""
          : (that.stockSell.limitPrice = that.stockSell.marketPrice);
      }
    },
    changeRouteInfo(deal, changeLimitPrice = false) {
      if (deal == "buy") {
        eventBus.$emit("symbol", this.stockBuy.info.toString().trim());
        this.$router.push({ name: 'Stockdetailed', query: { symbol: this.stockBuy.info.toString().trim(), cid: this.$route.query.cid, direction: this.tradeDirection } });
        this.$emit("changestockvalue", this.stockBuy.info);
      } else if (deal == "sell") {
        eventBus.$emit("symbol", this.stockSell.info.toString().trim());
        this.$router.push({ name: 'Stockdetailed', query: { symbol: this.stockSell.info.toString().trim(), cid: this.$route.query.cid, direction: this.tradeDirection } });
        this.$emit("changestockvalue", this.stockSell.info);
      }



      this.changeInfo(deal, changeLimitPrice);



    },
    //修改股票信息
    //pass optional paramater changeLimitPrice to change the limit price value in the input
    changeInfo(deal, changeLimitPrice = false) {
      let that = this;
      if (deal === "buy") {
        $.ajax({
          url: "https://qt.gtimg.cn/q=" + that.stockBuy.info.toString(),
          type: "GET",
          dataType: "script",
          cache: true,
          success: function () {
            let elements = eval("v_" + that.stockBuy.info).split("~");
            $.each(that.stockBuy.buyArr, function (index, item) {
              item.price = elements[index * 2 + 9];
              item.number = elements[index * 2 + 10];
            });
            $.each(that.stockBuy.sellArr, function (index, item) {
              item.price = elements[27 - index * 2];
              item.number = elements[28 - index * 2];
            });
            that.stockBuy.marketPrice = elements[3];//that.stockBuy.sellArr[4].price;
            if (changeLimitPrice)
              that.stockBuy.limitPrice = that.stockBuy.sellArr[4].price;
            // that.stockBuy.limitPrice =  that.stockBuy.sellArr[4].price;
            that.stockBuy.hardenPrice = elements[47];
            that.stockBuy.dropPrice = elements[48];
          },
        });
        clearInterval(window.timer3);
        window.timer3 = setInterval(function () {
          that.changeInfo("buy");
        }, 1000);
      } else if (deal === "sell") {
        $.ajax({
          url: "https://qt.gtimg.cn/q=" + that.stockSell.info.toString(),
          type: "GET",
          dataType: "script",
          cache: true,
          success: function () {
            let elements = eval("v_" + that.stockSell.info).split("~");
            $.each(that.stockSell.buyArr, function (index, item) {
              item.price = elements[index * 2 + 9];
              item.number = elements[index * 2 + 10];
            });
            $.each(that.stockSell.sellArr, function (index, item) {
              item.price = elements[27 - index * 2];
              item.number = elements[28 - index * 2];
            });
            that.stockSell.marketPrice = elements[3];//that.stockSell.buyArr[0].price;
            if (changeLimitPrice)
              that.stockSell.limitPrice = that.stockSell.buyArr[0].price;
            // that.stockSell.limitPrice = that.stockSell.buyArr[0].price;
            that.stockSell.hardenPrice = elements[47];
            that.stockSell.dropPrice = elements[48];
          },
        });
        let sellable = 0;
        for (let i = 0, len = that.holdData.length; i < len; i++) {
          if (that.holdData[i].short.trim() === that.stockSell.info.trim()) {
            sellable = that.holdData[i].sellable;
          }
        }
        that.stockSell.validNumber = sellable;
        clearInterval(window.timer2);
        window.timer2 = setInterval(function () {
          that.changeInfo("sell");
        }, 1000);
      }
    },
    //快速选仓
    position(storehouse) {
      let that = this;
      switch (storehouse) {
        case "buyFull":
          if (that.changeBuyType) {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  (Number(that.UserAvailable) - Number(this.totalFee)) / Number(that.stockBuy.marketPrice)
                ) / 100
              ) * 100;
          } else {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  (Number(that.UserAvailable) - Number(this.totalFee)) / Number(that.stockBuy.limitPrice)
                ) / 100
              ) * 100;
          }
          break;
        case "buyThreeFourths":
          if (that.changeBuyType) {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    (Number(that.UserAvailable) - Number(this.totalFee)) /
                    Number(that.stockBuy.marketPrice)
                  ) * 0.75
                ) / 100
              ) * 100;
          } else {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    (Number(that.UserAvailable) - Number(this.totalFee)) /
                    Number(that.stockBuy.limitPrice)
                  ) * 0.75
                ) / 100
              ) * 100;
          }
          break;
        case "buyTwoFourths":
          if (that.changeBuyType) {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    (Number(that.UserAvailable) - Number(this.totalFee)) /
                    Number(that.stockBuy.marketPrice)
                  ) * 0.5
                ) / 100
              ) * 100;
          } else {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    (Number(that.UserAvailable) - Number(this.totalFee)) /
                    Number(that.stockBuy.limitPrice)
                  ) * 0.5
                ) / 100
              ) * 100;
          }
          break;
        case "buyOneFourths":
          if (that.changeBuyType) {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    (Number(that.UserAvailable) - Number(this.totalFee)) /
                    Number(that.stockBuy.marketPrice)
                  ) * 0.25
                ) / 100
              ) * 100;
          } else {
            that.stockBuy.number =
              parseInt(
                parseInt(
                  parseInt(
                    (Number(that.UserAvailable) - Number(this.totalFee)) /
                    Number(that.stockBuy.limitPrice)
                  ) * 0.25
                ) / 100
              ) * 100;
          }
          break;
        case "sellFull":
          that.stockSell.number =
            parseInt(parseInt(that.stockSell.validNumber) / 100) * 100;
          break;
        case "sellThreeFourths":
          that.stockSell.number =
            parseInt(parseInt(that.stockSell.validNumber * 0.75) / 100) * 100;
          break;
        case "sellTwoFourths":
          that.stockSell.number =
            parseInt(parseInt(that.stockSell.validNumber * 0.5) / 100) * 100;
          break;
        case "sellOneFourths":
          that.stockSell.number =
            parseInt(parseInt(that.stockSell.validNumber * 0.25) / 100) * 100;
          break;
      }
    },
    remoteMethod(query) {
      let that = this;
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = that.restaurants.filter((item) => {
            return (
              item.name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.short.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
              item.pinyin.toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    //购买股票
    buyStock() {
      let token = window.sessionStorage.getItem("token");
      let that = this;
      let buyPrice = 0;
      let mold = 0;
      if (that.changeBuyType) {
        mold = 2;
        buyPrice = Number(that.stockBuy.marketPrice);
      } else {
        mold = 1;
        buyPrice = Number(that.stockBuy.limitPrice);
      }
      let buyCode = that.stockBuy.info.replace(/[^0-9]/gi, "");
      let buyNumber = parseInt(that.stockBuy.number);
      if (that.isCapitalNotSelected==true){
					return;
				}
      else if (token === null) {
        this.$message.error({
          message: this.$t('stock.youHaveNotLogged'),
          onClose: function () {
            that.$router.push({ path: "/login" });
          },
        });
      } else if (buyCode === "" || isNaN(buyCode)) {
        this.$message.error({
          message: this.$t('stock.notSelectedStock'),
        });
      } else if (buyNumber === "" || isNaN(buyNumber)) {
        this.$message.error({
          message: this.$t('stock.notSelectedQuantity'),
        });
      } else {
        that
          .$confirm(
            // "以" +
            // buyPrice +
            // "元的价格买入" +
            // buyNumber +
            // "股, 是否继续?",
            // "买入股票",
            that.$t('stock.sureYouWantToBuy'),
            that.$t('stock.confTrans'),
            {
              confirmButtonText: that.$t('stock.sure'),
              cancelButtonText: that.$t('stock.cancel'),
              type: "warning",
            }
          )
          .then(() => {
            that
              .$http({
                url: "/app/Stock/buy_stock",
                method: "post",
                data: {
                  cid: that.operateData,
                  code: buyCode,
                  number: buyNumber,
                  price: buyPrice,
                  mold: mold,
                  direction: 0,
                },
              })
              .then(function (res) {
                if (res.data.status == 200) {
                  if (res.data.code == 1) {
                    that.$message({
                      message: that.$t(res.data.msgId),
                      type: "success",
                      duration: 1000,
                      onClose: function () {
                        that.getOperate();
                        that.stockBuy.number = "";
                      },
                    });
                  }
                  else if (res.data.code == 2) {
                    that.getTradeChannel();
                  } else {
                    that.$message.error(that.$t(res.data.msgId));
                  }
                } else {
                  that.$message.error(that.$t(res.data.msgId));
                }
              });
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: that.$t('stock.buyCancel'),
            });
          });
      }
    },
    //卖出股票
    sellStock() {
      let that = this;
      let holdFlag = false;
      for (let i = 0, len = that.holdData.length; i < len; i++) {
        if (that.holdData[i].short.trim() === that.stockSell.info.trim()) {
          holdFlag = true;
        }
      }

      let token = window.sessionStorage.getItem("token");

      let sellPrice = 0;

      let mold = 0;
      if (that.changeSellType) {
        mold = 2;
        sellPrice = Number(that.stockSell.marketPrice);
      } else {
        mold = 1;
        sellPrice = Number(that.stockSell.limitPrice);
      }
      let sellCode = that.stockSell.info.replace(/[^0-9]/gi, "");
      let sellNumber = parseInt(that.stockSell.number);

      if (that.isCapitalNotSelected==true){
					return;
				}
      else if (token === null) {
        this.$message.error({
          message: this.$t('stock.loginToSell'),
          onClose: function () {
            that.$router.push({ path: "/login" });
          },
        });
      } else if (!holdFlag) {
        that.stockSell.validNumber = 0;
        this.$message.error(that.$t('stock.stockNotPurchased'));
      } else if (sellCode === "" || isNaN(sellCode)) {
        this.$message.error({
          message: this.$t('stock.stockNotSelected'),
        });
      } else if (sellNumber === "" || isNaN(sellNumber)) {
        this.$message.error({
          message: this.$t('stock.sellQuantityNotSet'),
        });
      } else {
        that
          .$confirm(
            // "以" +
            // sellPrice +
            // "的价格卖出" +
            // sellNumber +
            // "股, 是否继续?",
            // "卖出股票",
            that.$t('stock.sureSellStock'),
            that.$t('stock.confTrans'),
            {
              confirmButtonText: that.$t('stock.sure'),
              cancelButtonText: that.$t('stock.cancel'),
              type: "warning",
            }
          )
          .then(() => {
            that
              .$http({
                url: "/app/Stock/sell_stock",
                method: "post",
                data: {
                  cid: that.operateData,
                  code: sellCode,
                  number: sellNumber,
                  price: sellPrice,
                  mold: mold,
                  direction: 0,
                },
              })
              .then(function (res) {
                if (res.data.status == 200) {
                  if (res.data.code == 1) {
                    that.$message({
                      message: that.$t(res.data.msgId),
                      type: "success",
                      duration: 1000,
                      onClose: function () {
                        that.getOperate();
                        that.stockSell.number = "";
                      },
                    });
                    /*that.$refs.child1.getStrategyInfo();
                        setTimeout(function() {
                          that.setNumber(that.maxNumber, that.ratio);
                          that.getHoldlist();
                          that.getInfo(that.short, 1);
                        }, 1000);*/
                  } else if (res.data.code == 2) {
                    that.getTradeChannel();
                  } else {
                    that.$message.error(that.$t(res.data.msgId));
                  }
                }
                else {
                  that.$message.error(that.$t(res.data.msgId));
                }
              });
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: that.$t('stock.sellCancelled'),
            });
          });
      }
    },
    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      that
        .$http({
          url: "/app/User/trade_popup",
          method: "post",
          data: {},
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
          }
        });
    },
    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/app/TradeChannalLog/modify_trade_status",
          method: "post",
          data: {
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.$message({
              message: that.$t(res.data.msgId),
              type: "success",
              duration: 1000,
            });
            that.showTradeChannelPopup = false;
            that.trade_channel_status = 0;
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //点击表格触发赋值
    buyHanddle(row, event, column) {
      let that = this;
      that.stockBuy.info = row.short;
      that.changeInfo("buy", true);
      that.remoteMethod(row.short);
      that.$emit("changestockvalue", row.short);
      that.$router.push({ name: 'Stockdetailed', query: { symbol: row.short.toString().trim(), cid: this.$route.query.cid, direction: that.tradeDirection } });
    },
    //点击卖出表格触发
    sellHanddle(row, event, column) {
      let that = this;
      that.stockSell.info = row.short;
      that.stockSell.validNumber = row.sellable;
      that.changeInfo("sell", true);
      that.remoteMethod(row.short);
      that.$emit("changestockvalue", row.short);
      that.$router.push({ name: 'Stockdetailed', query: { symbol: row.short.toString().trim(), cid: this.$route.query.cid, direction: that.tradeDirection } });
    },
    //持仓页面进入买入页面
    holdBuy(short) {
      let that = this;
      that.stockBuy.info = short;
      that.changeInfo("buy", true);
      that.remoteMethod(short);
      this.tabsName = "buyStock";
      that.$router.push({ name: 'Stockdetailed', query: { symbol: short.toString().trim(), cid: this.$route.query.cid, direction: that.tradeDirection } });
    },
    //持仓页面进入卖出页面
    holdSell(short) {
      let that = this;
      that.stockSell.info = short;
      that.changeInfo("sell", true);
      that.remoteMethod(short);
      this.tabsName = "sellStock";
      that.$router.push({ name: 'Stockdetailed', query: { symbol: short.toString().trim(), cid: this.$route.query.cid, direction: that.tradeDirection } });
    },
    //持仓页面进入行情页面
    marketGo(short) {
      let that = this;
      that.$router.push({ name: 'Stockdetailed', query: { symbol: short.toString().trim(), cid: this.$route.query.cid, direction: that.tradeDirection } });
    },
    //撤单
    handleCance(data) {
      let that = this;
      that
        .$http({
          url: "/app/Entrust/cancel_entrust",
          method: "post",
          data: {
            cid: that.operateData,
            order: data.id,
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.$message({
              message: that.$t(res.data.msgId),
              type: "success",
              duration: 1000,
              onClose: function () {
                that.changeOperate();
                that.getOperate();
              },
            });
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //时间格式数据
    timeTypeData(value) {
      let temp = [];
      for (let i = 0, len = value.length; i < len; i++) {
        if (!temp.includes(value[i].time)) {
          temp.push(value[i].time);
        }
      }
      for (let i = 0, len = temp.length; i < len; i++) {
        temp[i] = { index: i + 1, time: temp[i], children: [] };
        for (let j = 0, len1 = value.length; j < len1; j++) {
          if (temp[i].time === value[j].time) {
            value[j].index = parseInt((i + 1).toString() + (j + 1).toString());
            temp[i].children.push(value[j]);
          }
        }
      }
      return temp;
    },
    handleClick(tab, event) {
      let that = this;
      if (tab.name == "canceStock") {
        that.changeOperate();
      }
    },
  },
  mounted: function () {
    let that = this;
    this.stockBuy.info = this.$route.query.symbol;
    if (this.$store.state.loginType) {
      this.getOperate();
    }
    that.getStockFee();

    this.changeRouteInfo("buy", true);

  },
  watch: {
    $route() {
      if (this.tradeDirection != this.$route.query.direction) {
        this.tradeDirection = this.$route.query.direction || 0;
      }
    },
    "stockBuy.limitPrice": {
      handler: function (value) {
        let that = this;
        var str = value;
        var len1 = str.substr(0, 1);
        var len2 = str.substr(1, 1);
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
          str = str.substr(1, 1);
        }
        //第一位不能是.
        if (len1 == ".") {
          str = "";
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
          var str_ = str.substr(str.indexOf(".") + 1);
          if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
          }
        }
        if (str.length > 10) {
          str = str.substring(0, 10);
        }

        //正则替换，保留数字和小数点
        // str = str.replace(/[^\d^\.]+/g,'');
        //如果需要保留小数点后两位，则用下面公式
        str = str.replace(/\.\d\d\d$/, "");
        that.stockBuy.limitPrice = str;
      },
    },
    "stockSell.limitPrice": {
      handler: function (value) {
        let that = this;
        var str = value;
        var len1 = str.substr(0, 1);
        var len2 = str.substr(1, 1);
        //如果第一位是0，第二位不是点，就用数字把点替换掉
        if (str.length > 1 && len1 == 0 && len2 != ".") {
          str = str.substr(1, 1);
        }
        //第一位不能是.
        if (len1 == ".") {
          str = "";
        }
        //限制只能输入一个小数点
        if (str.indexOf(".") != -1) {
          var str_ = str.substr(str.indexOf(".") + 1);
          if (str_.indexOf(".") != -1) {
            str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
          }
        }
        if (str.length > 10) {
          str = str.substring(0, 10);
        }
        //正则替换，保留数字和小数点
        // str = str.replace(/[^\d^\.]+/g,'');
        //如果需要保留小数点后两位，则用下面公式
        str = str.replace(/\.\d\d\d$/, "");
        that.stockSell.limitPrice = str;
      },
    },
  },
  created() {
    let that = this;
    eventBus.$on("symbol", (symbol) => {
      that.holdBuy(symbol);
    });
  },
  beforeDestroy() {
    let that = this;
    clearTimeout(that.newPriceTimer);
    clearTimeout(window.timer2);
    clearTimeout(window.timer3);
  },
};
</script>
<style scoped>
.trading-section {
  border-radius: 15px;
  background-color: #040f1b;
  padding: 20px;
}

.submit {
  width: 100%;
}

.green {
  color: #008000;
}

.full_width {
  width: 100%;
}

.box-market {
  overflow: hidden;
  font-size: 14px;
  line-height: 1.5;
}

.container {
  width: 100%;
  max-width: 1200px;
  min-width: 1400px;
  margin: 10px auto;
}

#accountPicker>>>.el-input__inner {
  background-color: #12202e;
  border-radius: 7px;
  border: none;
  color: #a7acb2;
}

.el-tabs--border-card {
  border: none;
}

#tabs>>>.el-tabs__item {
  color: #ffffff;
}
#tabs >>> .el-tabs__item.is-active {
  color: var(--baseColor);
}

#tabs>>>.el-tabs__nav-wrap::after {
  background: none;
}

#tabs>>>.el-tabs__active-bar {
  background-color: var(--baseColor);
}

#buystock>>>.el-input__inner {
  background-color: #12202e;
  color: #c0c4cc;
  border: none;
}

.option-btn {
  background-color: #12202e;
  color: #ffffff;
  border: none;
  padding: 20px 0px;
  font-size: 15px;
}

.box-card {
  background-color: #12202e;
  border: none;
  color: #ffffff;
}

#buystockTable>>>.el-table th.is-leaf {
  background-color: #12202e;
  border: none;
}

#buystockTable>>>.el-table::before {
  display: none;
}

#buystockTable>>>.el-table__expanded-cell {
  background-color: #040F1B;
  color: #FFFFFF;
}

#buystockTable>>>.el-table__expanded-cell:hover {
  background-color: #040F1B !important;
  color: #FFFFFF !important;
}

#buystockTable>>>.el-form-item__label {
  color: #ffffff;
}
</style>
<style>
.el-select-dropdown__item.selected {
  color: var(--baseColor) !important;
}

.tradingChannelPop .el-dialog__body {
  padding: 0px 20px;
}
.returntoCapital .el-dialog__body {
  padding: 0px 20px !important;
}
.returntoCapital  {
  background-color:#FCF0F0 !important;
  border-radius: 10px !important;
  width:25% !important;
}
#buystockTableBottom .el-table::before {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/stocktrading.vue